import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { AdminService } from './admin.service';
import { AdminRole } from '../types/admin/admin-role';
import { AdminFacility } from '../types/admin/admin-facility';
import { AdminUser } from '../types/admin/admin-user';
import { AdminPanel } from '../types/admin/admin-panel';
import { User } from '../types/user';
import { LogService } from './log.service';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  constructor(
    private admin: AdminService,
    private session: SessionService,
    private log: LogService
  ) {}

  canDisplayHamburger(): boolean {
    return this.canEditUser() && !this.getSelectedUser().IsNew;
  }

  canEditUser(): boolean {
    const user = this.getSessionUser();
    // MX admin can edit all users
    if (user.isMxAdmin) {
      return true;
    }

    this.log.trace('Can edit user Default-> '+((user.isOrgAdmin || user.isFacAdmin) && !this.IsSelf()));
    // Org and fac admins cannot edit their own accounts
    return ((user.isOrgAdmin || user.isFacAdmin) && !this.IsSelf());
  }

  canEditEmail(): boolean {
    return this.getSelectedUser().IsNew;
  }

  canSelectOrgList(): boolean {
    if (this.getSelectedUser() && this.getSelectedUser().IsChanged) {
      return false;
    }
    return true;
  }

  canEditFacility(fac: AdminFacility): boolean {
    if (!this.canEditUser()) {
      return false;
    }

    const sessionUser = this.getSessionUser();
    const selectedUser = this.getSelectedUser();

    if (sessionUser.isOrgAdmin) {
      if (selectedUser.isOrgAdmin() || selectedUser.isFacAdmin()) {
        return false;
      }
    }

    if (sessionUser.isFacAdmin) {
      // fac admin can not change facilities of other admins
      if (selectedUser.isAdmin()) {
        return false;
      }
      // new users will have single facility preselected
      if (selectedUser.IsNew) {
        return false;
      }

      // for all other users, facility admins can only add their own facility
      if (sessionUser.getFirstFacilityCode() !== fac.FacilityCode) {
        return false;
      }
    }

    return true;
  }

  isAnalyzeGroup(role: AdminRole): boolean {
    const sessionUser = this.getSessionUser();
    const selectedUser = this.getSelectedUser();

    if (_.startsWith(_.toLower(role.GroupName), 'analyze')) {
        return true;
    }
    return false;
  }
  
  canEditRole(role: AdminRole): boolean {
    const sessionUser = this.getSessionUser();
    const selectedUser = this.getSelectedUser();

    if (sessionUser.isMxAdmin) {
      return true;
    }

    if (sessionUser.isOrgAdmin) {
      if (role.isMxAdmin()) {
        return false;
      }
      if (role.isParticipantAdmin()) {
        return selectedUser.getFacilityCount() > 1 ? false : true;
      }
    }

    if (sessionUser.isFacAdmin) {
      if (role.isMxAdmin() || role.isParticipantAdmin()) {
        return false;
      }
    }

    if (_.startsWith(_.toLower(role.GroupName), 'analyze')) {
        return false;
    }

    return this.canEditUser();
  }

  canEditPanel(panel: AdminPanel): boolean {
    const panelGroupName = _.split(_.toLower(panel.Description), '-', 1)[0].trim();
    if (
      !_.find(this.getSelectedUser().Applications, app =>
        (_.startsWith(app, panelGroupName) )
      )
    ) {
      this.log.trace('This panel is not notfy or analyze panel: '+panelGroupName);
      return false;
    }
    this.log.trace('Panel Gropup Name: '+panelGroupName);
    
    const sessionUser = this.getSessionUser();
    const selectedUser = this.getSelectedUser();
   
    if (_.startsWith(_.toLower(panel.GroupName), 'analyze')){
        return false;
    }
    // Mx admin Org and fac admins has full permission to make panel changes
    //these users can make changes to themself and also other users
    if ((sessionUser.isMxAdmin || sessionUser.isOrgAdmin || sessionUser.isFacAdmin)){
      this.log.trace('MX Admin or fac Admon or Org admin role');
      return true;
    }else{
      if (_.startsWith(_.toLower(panel.GroupName), 'notify')){
        if (selectedUser.hasNotifyRoles()){
          this.log.trace('Notify Roles ');
          return true;
        }
      }
    }
  }

  canSaveUser(): boolean {
    return this.canEditUser() && this.getSelectedUser().IsChanged;
  }

  private IsSelf() {
    return this.getSelectedUser().IsSelf;
  }

  private getSessionUser(): User {
    return this.session.getUser();
  }

  private getSelectedUser(): AdminUser {
    return this.admin.getSelectedUser();
  }
}
